'use client'

import { useEffect } from 'react'
import { usePathname, useSearchParams } from 'next/navigation'
import { getOrgSlugFromUrl } from '@/utilities/orgSlug'

function setPortalAttributes() {
  const html = document.documentElement
  const slug = (getOrgSlugFromUrl() || '').toLowerCase()
  const portal = slug === 'client' ? 'client' : 'patient'

  html.dataset.portal = portal
  if (slug) {
    html.dataset.slug = slug
  } else {
    delete html.dataset.slug
  }
}

export function HtmlPortalAttributes() {
  const pathname = usePathname()
  const searchParams = useSearchParams()

  useEffect(() => {
    setPortalAttributes()
  }, [pathname, searchParams])

  return null
}
